
import { defineComponent, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useEvent } from '@coderhouse/common'
import { getToast, shareSocialSharingNoti, omitSocialSharingNoti } from '@/api/social-sharing.api'

export default defineComponent({
  components: {},
  props: {
    opened: {
      type: Boolean,
      default: false,
      required: false
    },
    closeBtn: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  setup(props) {
    const { t } = useI18n()
    const showToast = ref()
    const toastInfo = ref()
    const socialLink = ref()

    onMounted(async () => {
      toastInfo.value = await getToast()
      if (toastInfo.value) {
        showToast.value = true
      }
    })

    const socialMediaLink = async () => {
      socialLink.value = await shareSocialSharingNoti(toastInfo.value.id)
      window.open(socialLink.value, '_blank')
      showToast.value = false
      useEvent('trackEvent', 'cta', 'social-sharing', 'compartir notificacion')
    }

    const getLinks = () => {
      socialMediaLink()
    }

    const closeToast = () => {
      omitSocialSharingNoti(toastInfo.value.id)
      useEvent('trackEvent', 'cta', 'social-sharing', 'omitir notificacion')
      showToast.value = false
    }

    return { t, closeToast, showToast, toastInfo, getLinks }
  }
})
